export enum TimeoutPeriod {
  DAY = 1,
  WEEK = 2,
  MONTH = 3,
  CUSTOM = 4,
}

export enum LimitTypeName {
  LOSS = 'loss',
  DEPOSIT = 'deposit',
}

export enum LimitType {
  LOSS = 1,
  DEPOSIT = 2,
}

export enum LimitPeriod {
  DAY = 1,
  WEEK = 2,
  MONTH = 3,
  CUSTOM = 4,
}

export enum selfExclusionPeriodKeys {
  MONTHS_6 = '6-m',
  YEAR_1 = '1-y',
  YEAR_2 = '2-y',
  YEAR_3 = '3-y',
  YEAR_4 = '4-y',
  YEAR_5 = '5-y',
}

export enum PRODUCT_BLOCK_ID {
  SPORTSBOOK = 0,
  CASINO = 100,
}

export enum STAYING_IN_CONTROL_MENU_ID {
  REALITY_CHECK = 'realityCheck',
  PRODUCT_BLOCK = 'productBlock',
  SELF_EXCLUSION = 'selfExclusion',
}

export enum PRODUCT_BLOCK_TYPE {
  SPORTSBOOK = 'sportsbook',
  CASINO = 'casino',
}

export enum PERIOD_TIMEFRAME_ID {
  DAYS = 1,
  WEEKS = 2,
  MONTHS = 3,
}
